import { create } from "zustand";

const useSessionStore = create((set) => ({
  activeSession: null,
  sessionNow: Date.now(),

  startSession: (client, aiSession = null) =>
    set({ activeSession: { client, aiSession, startedAt: Date.now() } }),

  endSession: () => set({ activeSession: null }),

  tick: () => set({ sessionNow: Date.now() }),
}));

export default useSessionStore;
